import React from 'react';
import { SortableElement } from 'react-sortable-hoc';
import classNames from 'classnames';
import { ImageType } from '@types';
import Image from '@components/Image';
import Icon from '@components/Icon';
import ImgTrash from './img-trash.png';

interface Props {
  listIndex: number;
  src: string;
  active?: boolean;
  onClick: (index: number) => void;
  onDeleteClick: (index: number) => void;
}

function Item({ listIndex, src, active, onClick, onDeleteClick }: Props) {
  return (
    <div
      className={classNames('relative m-5 h-60 w-60 focus:outline-none', {
        'ring-2 ring-orange': active,
      })}
      onClick={() => onClick(listIndex)}
    >
      <Image src={src} className="h-full w-full" type={ImageType.media} />
      <Icon
        src={ImgTrash}
        className="absolute right-5 top-5 cursor-pointer rounded-xs bg-black-border hover:bg-blue"
        onClick={(e) => {
          e.stopPropagation();
          onDeleteClick(listIndex);
        }}
      />
    </div>
  );
}

export default SortableElement(Item);
